/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CmsFormData } from '../models/CmsFormData';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CmsService {
    /**
     * Save form data to Elasticsearch index
     * @returns void
     * @throws ApiError
     */
    public static postApiVCmsFormData({
        requestBody,
        apiVersion = 1,
    }: {
        requestBody: CmsFormData,
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/cms/form-data',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input.`,
                500: `Internal server error.`,
            },
        });
    }
    /**
     * Get info if form is valid with desired parameters
     * @returns any Success
     * @throws ApiError
     */
    public static postApiVCmsFormValidate({
        requestBody,
        apiVersion = 1,
    }: {
        requestBody: {
            /**
             * Identifier for the form this data belongs to.
             */
            formId?: string;
            /**
             * Receipt number.
             */
            receiptNumber?: string | null;
        },
        apiVersion?: number,
    }): CancelablePromise<{
        maxCount?: 'not_checked' | 'valid' | 'invalid';
        receiptNumber?: 'not_checked' | 'valid' | 'invalid';
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/cms/form-validate',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid input.`,
                500: `Internal server error.`,
            },
        });
    }
}
